__turbopack_context__.v({
  "className": "eX5U3G_className",
  "variable": "eX5U3G_variable",
});
